import AnalysisCard from './AnalysisCard'

export default AnalysisCard
